import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { ConfigService } from '../../config/shared/config.service';

/**
 * Used to show a component/section of a page if a customer has access to a beta feature.
 *
 * Works like *ngIf: if the customer does not have the beta feature enabled, the component is not in the DOM.
 *
 * @example:
 *  <p *wlHasBetaFeature="'autoEmailStuff'">Thank you for beta testing this feature.</p>
 */
@Directive({
  selector: '[wlHasBetaFeature]',
  standalone: false
})
export class WlHasBetaFeatureDirective {
  /**
   * value is the feature name
   */
  @Input() public set wlHasBetaFeature(featureName: string) {
    this._configService.hasBetaFeatureEnabled(featureName).then(hasIt => {
      // if it has it and it's off, add it (don't re-add if it's on)
      if (hasIt && !this._on) {
        // add it
        this._viewContainer.createEmbeddedView(this._templateRef);
        this._on = true;
      } else if (!hasIt && this._on) {
        // remove
        this._viewContainer.clear();
        this._on = false;
      }
    });
  }

  // to track when view is created
  private _on: boolean = false;

  /**
   * construct
   * @param _configService
   * @param _templateRef
   * @param _viewContainer
   */
  constructor(public _configService: ConfigService, private _templateRef: TemplateRef<any>, private _viewContainer: ViewContainerRef) {}
}
